<div #outerMessage class="outer-message" *ngIf="ready">
  <div *ngIf="displayTopTime" class="top-time">
    <span style="display: flex; justify-content: center">
      <time [dateTime]="isoTime"> {{ topTime }}</time>
    </span>
  </div>

  <div
    class="main"
    [ngClass]="userId === authUserId ? 'from-me-main' : 'from-them-main'"
  >
    <div *ngIf="userId === authUserId"></div>

    <div class="button-div" *ngIf="userId === authUserId">
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Open message menu"
        class="menu-button"
        [ngClass]="{ 'show-menu-button': showMenuButton }"
        (click)="showMenuButton = true"
      >
        <mat-icon [ngClass]="theme">more_horiz</mat-icon>
      </button>
    </div>

    <div
      class="main-inner"
      [ngClass]="{ stacked: stacked }"
      [style.background-color]="
        theme === 'dark-theme'
          ? 'hsl(' + backgroundColor + 'deg 60% 35%)'
          : 'hsl(' + backgroundColor + 'deg 60% 45%)'
      "
      (click)="toggleSubTime()"
    >
      <div *ngIf="displaySenderUser && user" class="sender-name">
        <span>{{ user.name }}</span>
      </div>

      <div class="message-body">
        <div
          [style.margin-bottom]="body ? '14px' : '0px'"
          *ngIf="mediaUrl"
          (click)="launchImageDialog(imageDialog)"
        >
          <img class="message-media" [src]="mediaUrl" />
        </div>
        <div class="message-text" *ngIf="body">{{ body }}</div>

        <div *ngIf="error" class="error">
          <span> <mat-icon inline="true">warning</mat-icon> Error: </span><br />
          <span *ngIf="errorString"> Errors: {{ errorString }}. </span>
        </div>
      </div>

      <div
        *ngIf="displaySubTime"
        class="sub-time"
        [ngClass]="{ 'sub-time-me': userId === authUserId }"
      >
        <time [dateTime]="isoTime"> {{ subTime }}</time>
      </div>
      <div *ngIf="userId === authUserId" class="message-status">
        <span>
          <mat-icon
            [style.opacity]="messageStatus === 'done' ? '0.5' : '1'"
            class="icon-style"
          >
            {{ messageStatus }}
          </mat-icon>
        </span>
      </div>
    </div>

    <div class="button-div" *ngIf="userId !== authUserId">
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Open message menu"
        class="menu-button"
        [ngClass]="{ 'show-menu-button': showMenuButton }"
        (click)="showMenuButton = true"
      >
        <mat-icon [ngClass]="theme">more_horiz</mat-icon>
      </button>
    </div>

    <div *ngIf="userId !== authUserId"></div>
  </div>

  <mat-menu #menu="matMenu" (closed)="showMenuButton = false">
    <!-- TODO: implement this -->
    <button mat-menu-item (click)="replyTo()">
      <mat-icon>reply</mat-icon>
      <span>Reply to this message</span>
    </button>
    <!-- TODO: implement this -->
    <button mat-menu-item (click)="forkThread()">
      <mat-icon>reply</mat-icon>
      <span>Fork from this message</span>
    </button>
    <!-- TODO: implement this -->
    <button mat-menu-item (click)="showRawData()">
      <mat-icon>description</mat-icon>
      <span>Raw data</span>
    </button>
    <!-- TODO: implement this -->
    <button mat-menu-item (click)="deleteMessage()">
      <mat-icon>delete</mat-icon>
      <span>Delete</span>
    </button>
  </mat-menu>

  <div>
    <ng-container *ngFor="let update of updates">
      <app-thread-user-update-display
        *ngIf="update.updateType === 'user'"
        [orgId]="orgId"
        [update]="update.update"
      ></app-thread-user-update-display>
      <app-thread-title-update-display
        *ngIf="update.updateType === 'title'"
        [orgId]="orgId"
        [update]="update.update"
      ></app-thread-title-update-display>
    </ng-container>
  </div>
</div>

<ng-template #imageDialog>
  <div>
    <img [src]="imageDialogUrl" class="image-dialog-image" />
  </div>
</ng-template>
